module.exports = __webpack_public_path__ + "static/media/pdf_file.17edb8d6.svg";